import 'slick-carousel';

export default (function() {
	// let _$nav = null;
	let _$carousel = null;

	function init($carousel) {
		_$carousel = $carousel;

		if (_$carousel.length > 0) {
			$(_$carousel).each((i, carousel) => {
				let _$nav = $(carousel).siblings('.js-carousel-nav');
				$(carousel).slick({
					cssEase     : 'cubic-bezier(0.15, 0, 0, 1)',
					infinite    : true,
					speed       : 500,
					dots        : false,
					fade        : false,
					appendArrows: _$nav,
					prevArrow   : '<a class="slick-prev slick-arrow" href="#"><i class="icon icon-chevron-left" aria-hidden="true"></i></a>',
					nextArrow   : '<a class="slick-next slick-arrow" href="#"><i class="icon icon-chevron-right" aria-hidden="true"></i></a>',
				});
			})

			onResize();
			$(window).on('resize', () => {
				onResize();
			});
		}
	}

	// slick slider resize is broken, and can only work with pixel dimensions on its container
	function onResize() {
		if (!_$carousel) {
			return;
		}
		$(_$carousel).each((i, carousel) => {
			$(carousel).css({
				'width' : '',
				'height': ''
			});

			$(carousel).css({
				'width' : $(carousel).parent().width(),
				'height': $(carousel).parent().height()
			});
		});


	}

	return {
		init,
	};
})();